module.exports = __webpack_public_path__ + "img/PL08520.81ecb9e1.png";